import {Utilities} from '../../shared/utilities/utilities.model';
/**
 * Created by wladimir on 22/05/18.
 */
export class NotificationItemList {

	notification_id: string;
	created_at: string;
	user_id: string;
	user_Ids: string[];
	module: string;
	ald_order_id: string;
	title: string;
	text: string;
	action: string;
	metadata: Map<string, string>;
	is_read: boolean;

	constructor(model?: any) {
		this.metadata = new Map<string, string>();
		if (!Utilities.isVoid(model)) {
			this.notification_id = model.notification_id;
			this.created_at = model.created_at;
			this.user_id = model.user_id;
			this.user_Ids = [];
			if (!Utilities.isVoid(model.user_Ids)) {
				for (let i = 0; i < model.user_Ids.length; i++) {
					this.user_Ids.push(model.user_Ids[i]);
				}
			}
			this.module = model.module;
			this.ald_order_id = model.ald_order_id;
			this.title = model.title;
			this.text = model.text;
			this.action = model.action;
			this.is_read = model.is_read;
			if (!Utilities.isVoid(model.metadata)) {
				const keys = Object.keys(model.metadata);
				for (const key of keys) {
					this.metadata.set(key, model.metadata[key]);
				}
			}
		}
	}

}
